<template>
    <div id="adsense">
      <Adsense
        data-ad-client="ca-pub-6042959271745689"
        data-ad-slot="1229520100">
      </Adsense>
    </div>
</template>

<script>
export default {
  name: 'adsense'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Adsense.vue